type RuntimeWindow = typeof window & { ENVIRONMENT?: string };

const getEnvironment = (): string => {
  const runtimeEnv =
    typeof window !== "undefined"
      ? (window as RuntimeWindow).ENVIRONMENT
      : undefined;
  const buildEnv =
    process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV || "test";
  return (runtimeEnv || buildEnv).toLowerCase();
};

const isProd = (): boolean => {
  const env = getEnvironment();
  return env === "prod" || env === "production";
};

export const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (isProd()
    ? "https://ssz1nsz7v8.execute-api.us-east-2.amazonaws.com"
    : "https://3bb9xtr738.execute-api.us-east-2.amazonaws.com");

export const AUTH_API_URL =
  process.env.REACT_APP_AUTH_URL ||
  (isProd()
    ? "https://3xcmymwh19.execute-api.us-east-2.amazonaws.com"
    : "https://n551r3kwqa.execute-api.us-east-2.amazonaws.com");

export const getApiUrl = (path: string): string => {
  return `${API_BASE_URL}${path}`;
};

export const getAuthUrl = (path: string): string => {
  return `${AUTH_API_URL}${path}`;
};
